import { WorkDayType, WorkingHoursData } from '../../../../../api';

const SLOT_SECONDS = 30 * 60;
const SECONDS_PER_HOUR = 60 * 60;
const DEFAULT_FIRST_SLOT = 6 * SECONDS_PER_HOUR;
const DEFAULT_LAST_SLOT = 23 * SECONDS_PER_HOUR + SLOT_SECONDS;
const NOON = 12 * SECONDS_PER_HOUR;
const EVENING_START = 17 * SECONDS_PER_HOUR;

export enum DayPart {
  Morning = 'morning',
  Afternoon = 'afternoon',
  Evening = 'evening',
}

const slotsBetween = (firstSlot: number, endExclusive: number): number[] => {
  const slots: number[] = [];
  for (let slot = firstSlot; slot < endExclusive; slot += SLOT_SECONDS) {
    slots.push(slot);
  }
  return slots;
};

const defaultSlots = (): number[] => slotsBetween(DEFAULT_FIRST_SLOT, DEFAULT_LAST_SLOT + SLOT_SECONDS);

// Start times offered for one weekday of the page's working hours, in seconds from midnight.
export const startTimeSlots = (hours: WorkingHoursData | undefined): number[] => {
  if (hours?.work_day_type === WorkDayType.INTERVAL && hours.from_time !== undefined && hours.to_time !== undefined) {
    return slotsBetween(hours.from_time, hours.to_time);
  }
  if (hours?.work_day_type === WorkDayType.FIXED && hours.start_seconds && hours.start_seconds.length > 0) {
    return [...hours.start_seconds].sort((first, second) => first - second);
  }
  return defaultSlots();
};

export const dayPartOf = (seconds: number): DayPart => {
  if (seconds < NOON) {
    return DayPart.Morning;
  }
  return seconds < EVENING_START ? DayPart.Afternoon : DayPart.Evening;
};

export const groupSlotsByDayPart = (slots: number[]): { part: DayPart; slots: number[] }[] =>
  [DayPart.Morning, DayPart.Afternoon, DayPart.Evening]
    .map((part) => ({ part, slots: slots.filter((slot) => dayPartOf(slot) === part) }))
    .filter((group) => group.slots.length > 0);
